var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicensePlate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "464pt",
    viewBox: "0 -88 464.008 464",
    width: "464pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m432 32.003906h-400v224h400zm-384 16h16v16h-16zm16 192h-16v-16h16zm32-56c13.230469 0 24-10.769531 24-24h16c0 22.054688-17.945312 40-40 40s-40-17.945312-40-40v-32c0-22.054687 17.945312-40 40-40s40 17.945313 40 40h-16c0-13.230468-10.769531-24-24-24s-24 10.769532-24 24v32c0 13.230469 10.769531 24 24 24zm56-48h48v16h-48zm112-8c0 6.167969-2.40625 11.742188-6.238281 16 3.839843 4.257813 6.238281 9.832032 6.238281 16v16c0 13.230469-10.769531 24-24 24h-40v-16h40c4.414062 0 8-3.59375 8-8v-16c0-4.40625-3.585938-8-8-8h-24v-16h24c4.414062 0 8-3.59375 8-8v-16c0-4.40625-3.585938-8-8-8h-40v-16h40c13.230469 0 24 10.769532 24 24zm80 56v16h-64v-19.3125l39.03125-39.03125c5.785156-5.785156 8.96875-13.480468 8.96875-21.65625 0-8.824218-7.175781-16-16-16s-16 7.175782-16 16v8h-16v-8c0-17.648437 14.351562-32 32-32s32 14.351563 32 32c0 12.457032-4.847656 24.167969-13.65625 32.96875l-31.03125 31.03125zm16 0h16v-80h-16v-16h32v96h16v16h-48zm56 56h-16v-16h16zm0-176h-16v-16h16zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m464 .00390625h-464v287.99999975h464.007812zm-16 271.99999975h-432v-256h432zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicensePlate);
export default __webpack_public_path__ + "static/media/license-plate.1f791c7e2886a015774d601df7f71c78.svg";
export { ForwardRef as ReactComponent };